var Component = require("!../../_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./swiper.vue"),
  /* template */
  require("!!../../_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7f7b00a9\"}!../../_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./swiper.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-awesome-swiper@2.6.7@vue-awesome-swiper/src/swiper.vue
// module id = 142
// module chunks = 19